import { render, staticRenderFns } from "./FooterFlags.vue?vue&type=template&id=705399b6&scoped=true&"
import script from "./FooterFlags.vue?vue&type=script&lang=js&"
export * from "./FooterFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705399b6",
  null
  
)

export default component.exports